import type { BannerBlock } from '@/types'
import { BlockTypes } from '@/types'

import { onBeforeMount } from 'vue'

import { storeToRefs } from 'pinia'
import { useBlocksStore } from '@/stores/blocks'

import { getBannerMediaPath } from '@/helpers'
/**
 * Пример для 1 из 2 изображений banner_2 (смотре CustomerPicture для доп. инфы)
 *   <link
 *     rel="preload"
 *     imagesrcset="/i/banner_2_large/contents/blocks/2d1e36ea-5be0-4b6a-aac7-1407f290ab6f.jpg,
 *         /i/banner_2_large_2x/contents/blocks/2d1e36ea-5be0-4b6a-aac7-1407f290ab6f.jpg 2x
 *       "
 *     as="image"
 *     media="(min-width: 1024.1px)"
 *   />
 *   <link
 *     rel="preload"
 *     imagesrcset="
 *         /i/banner_2_medium/contents/blocks/2d1e36ea-5be0-4b6a-aac7-1407f290ab6f.jpg,
 *         /i/banner_2_medium_2x/contents/blocks/2d1e36ea-5be0-4b6a-aac7-1407f290ab6f.jpg 2x
 *       "
 *     as="image"
 *     media="(min-width: 768px) and (max-width: 1024px)"
 *   />
 *   <link
 *     rel="preload"
 *     imagesrcset="/i/banner_2_medium/contents/blocks/2d1e36ea-5be0-4b6a-aac7-1407f290ab6f.jpg,
 *         /i/banner_2_medium_2x/contents/blocks/2d1e36ea-5be0-4b6a-aac7-1407f290ab6f.jpg 2x
 *       "
 *     as="image"
 *     media="(max-width: 767px)"
 *   />
 * */
export const useBannerBlockImagePreloader = () => {
  const blocksStore = useBlocksStore()
  const { isLoading: blocksAreLoading, blocks } = storeToRefs(blocksStore)

  onBeforeMount(async () => {
    if (
      window.location.pathname === '/' &&
      !blocks.value.length &&
      !blocksAreLoading.value
    ) {
      await blocksStore.fetch('c')

      if (blocks.value[0]?.type === BlockTypes.Banner2) {
        addBlockImagesPreloader(blocks.value[0] as BannerBlock)
      }
    }
  })

  function addBlockImagesPreloader(block: BannerBlock) {
    block.parameters.banners.forEach((_, index) => {
      const srcSet = getBannerMediaPath(block, index).srcSet
      if (!srcSet) return

      addImagePreloader(srcSet)
    })
  }

  function addImagePreloader(srcSet: string[]) {
    addLink(srcSet[0], '(min-width: 1024.1px)')
    addLink(srcSet[1], '(min-width: 768px) and (max-width: 1024px)')
    addLink(srcSet[2], '(max-width: 767px)')
  }

  function addLink(srcSet: string, media: string) {
    const link = document.createElement('link')

    link.rel = 'preload'
    link.as = 'image'
    link.imageSrcset = srcSet
    link.media = media

    document.head.appendChild(link)
  }
}
